import { Agent } from './agent';
import { Group } from './group';
import { IAgent } from '../resources/istatement/agent';
import { IContext } from '../resources/istatement/context';
import { IExtensions } from '../resources/istatement/extensions';
import { IGroup } from '../resources/istatement/group';
import { IStatementRef } from '../resources/istatement/statement_ref';
import { Versions } from '../constants/versions';
import { StatementRef } from './statement_ref';
import { IActor } from '../resources/istatement/actor';
import { ContextActivities } from './context_activity';

export interface ContextParams {
	registration?: string;
	instructor?: Agent | Group | IAgent | IGroup;
	team?: Agent | Group | IAgent | IGroup;
	contextActivities?: any;
	revision?: string;
	platform?: any;
	language?: string;
	statement?: StatementRef | IStatementRef | { [key: string]: any };
	extensions?: IExtensions;
	[key: string]: any;
}

export class Context {
	registration?: string;
	instructor?: Agent | Group;
	team?: Agent | Group;
	contextActivities?: ContextActivities;
	revision?: string;
	platform?: any;
	language?: string;
	statement?: StatementRef;
	extensions?: IExtensions;

	constructor(cfg: ContextParams = {}) {
		const { registration, revision, platform, language, extensions } = cfg;

		this.instructor = this.agent_group(cfg.instructor);
		this.team = this.agent_group(cfg.team);

		this.registration = registration;
		this.revision = revision;
		this.platform = platform;
		this.language = language;
		this.extensions = extensions;

		if (cfg.contextActivities) {
			if (cfg.contextActivities instanceof ContextActivities) {
				this.contextActivities = cfg.contextActivities;
			} else {
				this.contextActivities = new ContextActivities(cfg.contextActivities);
			}
		}

		if (cfg.statement) {
			if (cfg.statement instanceof StatementRef) {
				this.statement = cfg.statement;
			} else if (cfg.statement.objectType === 'StatementRef') {
				this.statement = new StatementRef(cfg.statement);
			}
		}
	}

	private agent_group(value: Agent | Group | IActor | IGroup | undefined): Agent | Group | undefined {
		if (value === undefined) {
			return undefined;
		}
		if (value.objectType === undefined || value.objectType === 'Person') {
			value.objectType = 'Agent';
		}

		if (value.objectType === 'Agent') {
			if (value instanceof Agent) {
				return value;
			} else {
				return new Agent(value);
			}
		} else if (value.objectType === 'Group') {
			if (value instanceof Group) {
				return value;
			} else {
				return new Group(value);
			}
		}
	}

	asVersion(version: Versions = '1.0.3'): IContext {
		const result: IContext = {};

		// SubStatement is not supported in >= 1.0.0
		result.registration = this.registration;
		result.revision = this.revision;
		result.platform = this.platform;
		result.language = this.language;
		result.extensions = this.extensions;

		result.instructor = this.instructor && this.instructor.asVersion(version);
		result.team = this.team && this.team.asVersion(version);
		// result.contextActivities = this.contextActivities && this.contextActivities.asVersion(version);
		result.statement = this.statement && this.statement.asVersion(version);

		return result;
	}

	static fromJSON(contextJSON: string): Context {
		const _context = JSON.parse(contextJSON);

		return new Context(_context);
	}
}
